<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import './assets/css/normalize.css';
@import './assets/css/main.css';
@import './assets/fonts/fonts.css';
@import './assets/fonts/font-awesome/css/font-awesome.css';
#app {

}
</style>



// WEBPACK FOOTER //
// App.vue?b2e1b086